import React from 'react';
import StarIcon from '@mui/icons-material/Star';
import { Box, Typography } from '@mui/material';

interface RatingSummaryStarRatingProps {
  average: number;
  maxStars?: number;
  size?: number;
}

export const RatingSummaryStarRating = ({ average, maxStars = 5, size = 20 }: RatingSummaryStarRatingProps) => {
  const safeAverage = Number.isFinite(average) ? average : 0;

  return (
    <Box sx={{ display: 'flex', gap: 2, mb: 1 }}>
      <Typography variant="h3" sx={{ fontWeight: 700 }}>
        {safeAverage.toFixed(2)}
      </Typography>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 0.5,
        }}
      >
        {Array.from({ length: maxStars }, (_, i) => {
          const filled = i < Math.floor(safeAverage);
          const partial = !filled && i < safeAverage;
          return (
            <StarIcon
              key={i}
              sx={{
                fontSize: size,
                color: filled || partial ? 'warning.main' : 'grey.300',
                opacity: partial ? 0.5 : 1,
              }}
            />
          );
        })}
      </Box>
    </Box>
  );
};
